/*
 * A Menu or a Select docked as an action sheet, on `compact`. Neither is a Drawer: Base UI
 * positions both with Floating UI, which writes `position`, its coordinates and a transform onto the
 * positioner's inline style on every frame. These classes outrank that style with `!important` to
 * stand the positioner at the bottom of the screen, full width (centred, 36rem at most, on a
 * tablet), and restyle the popup as a sheet: the dialog's shadow, its top corners rounded, under the
 * handle every bottom sheet carries (`BottomSheetHandle`, pinned by `handle` while the list
 * scrolls), 44px rows on touch, clear of the home indicator, over the scrim. Its geometry is every bottom sheet's
 * (`max-h-sheet`, `pb-sheet-*` in `tokens.css`) and so is its motion: rising over 200ms on the snappy
 * curve, falling over 150ms, as the Drawer does.
 *
 * FRAGILE: this leans on Base UI's positioner writing only inline `position`, `top`, `left`,
 * `right`, `bottom` and `transform`. A Base UI upgrade that positions another way (a `translate`, a
 * CSS anchor, a wrapper of its own) breaks the docked form silently. After any upgrade of
 * `@base-ui/react`, open the kitchen sink's "Overlays as sheets" specimens (Compact and touch) and
 * check that the menu, its submenu and the Select still dock at the bottom.
 */
export const actionSheet = {
  positioner:
    "fixed! inset-x-0! top-auto! bottom-0! mx-auto w-full max-w-xl transform-none! translate-none!",
  popup:
    "z-50 flex max-h-sheet w-full flex-col overflow-x-hidden overflow-y-auto rounded-t-xl bg-popover p-2 pt-0 pb-sheet-2 text-ui text-popover-foreground shadow-dialog duration-200 ease-snappy outline-none data-open:animate-in data-open:slide-in-from-bottom data-closed:animate-out data-closed:duration-150 data-closed:slide-out-to-bottom",
  handle: "sticky top-0 z-10 -mx-2 bg-popover",
  backdrop:
    "fixed inset-0 z-50 bg-scrim duration-200 ease-snappy data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:duration-150 data-closed:fade-out-0",
} as const
